export { default as Shipping } from './Shipping'; 